import { DeviceListResponse, HealthResponse, ImageListResponse, ImageRecord } from "@rb/common";

// All requests go to the same origin under /api. In dev, Vite proxies them to
// the local @rb/api service; in production Caddy does.
const API_BASE = "/api";

export function fetchHealth(): Promise<HealthResponse> {
  return request<HealthResponse>("/health");
}

// ---- images (reads are public; uploads come from the phones with a bearer token) ----

export function fetchDevices(): Promise<DeviceListResponse> {
  return request<DeviceListResponse>("/devices");
}

export function fetchImages(options: {
  deviceId?: string | null;
  before?: string | null;
  limit?: number;
}): Promise<ImageListResponse> {
  const params = new URLSearchParams();
  if (options.deviceId) params.set("deviceId", options.deviceId);
  if (options.before) params.set("before", options.before);
  if (options.limit !== undefined) params.set("limit", String(options.limit));
  const query = params.toString();
  return request<ImageListResponse>(`/images${query === "" ? "" : `?${query}`}`);
}

export function imageFileUrl(image: Pick<ImageRecord, "id">): string {
  return `${API_BASE}/images/${image.id}/file`;
}

export class ApiError extends Error {
  readonly status: number;

  constructor(status: number, statusText: string) {
    super(`${status} ${statusText}`);
    this.name = "ApiError";
    this.status = status;
  }
}

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await send(path, init);
  return (await response.json()) as T;
}

async function send(path: string, init: RequestInit): Promise<Response> {
  const response = await fetch(API_BASE + path, {
    ...init,
    headers: { "Content-Type": "application/json", ...init.headers },
  });
  if (!response.ok) {
    throw new ApiError(response.status, response.statusText);
  }
  return response;
}
